<template>
	<inertia-head title="Email Swipes" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Email Swipes</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Welcome to TRC Admin Dashboard
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="text-end mb-4">
			<button @click="viewEmailSwipeContentModal(0,'add')" class="btn btn-alt-primary">
				<i class="fa fa-plus me-1"></i>
				Add Email Swipe
			</button>
		</div>
		<div class="block">
			<div class="block-content block-content-full">
				<div class="table-responsive">
					<table class="table table-borderless table-striped table-vcenter">
						<thead>
							<tr>
								<th>Title</th>
								<th>Email format</th>
								<th>Category</th>
								<th>Status</th>
								<th>Date Created</th>
								<th class="text-end">:::::</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(swipe, index) in emailSwipes.data" :key="index">
								<td>{{ swipe.title }}</td>
								<td>{{ swipe.email_short }}</td>
								<td>{{ swipe.category }}</td>
								<td>
									<span class="badge" :class="{'bg-success':swipe.status==1,'bg-danger':swipe.status==0}">{{ swipe.status_format }}</span>
								</td>
								<td>{{ swipe.date_created }}</td>
								<td class="text-end">
									<button @click="viewEmailSwipeContentModal(index,'update')" class="btn btn-sm btn-alt-info me-1"><i class="fa fa-pencil-alt"></i></button>
									<button @click="confirmDelete(index)" class="btn btn-sm btn-alt-danger"><i class="fa fa-times" data-toggle="modal" data-backdrop="static" data-target="#DeleteDialog"></i></button>
								</td>
							</tr>
							<tr v-if="emailSwipes.data.length <= 0" >
								<td colspan="6" class="text-center"><p class="mb-0 fw-semibold">NO EMAIL SWIPE FOUND.</p></td>
							</tr>
						</tbody>
					</table>
				</div>
				<pagination :collections="emailSwipes" />
			</div>
		</div>


		<modal ref="deleteModal">
			<template #title>DELETE CONFIRMATION</template>
			<template #body>
				<div class="text-center">
                    <p class="h6">
                        Are you sure, you want to delete this Email Swipe?
                    </p>
                </div>
			</template>
			<template #footer>
				<button type="button" @click="deleteEmailSwipe()" class="btn btn-alt-primary btn-sm"><i class="fa fa-check-circle"></i> YES</button>
                <button @click="deleteModal.toggleModal" type="button" id="btnDeleteClose" class="btn btn-alt-danger btn-sm"><i class="fa fa-times-circle"></i> NO</button>
			</template>
		</modal>

		
		<add-update-email-swipe-modal
		ref="addUpdateEamilSwipeModal"
		></add-update-email-swipe-modal>
	</div>
</template>

<script>
import { onMounted, ref, watch, reactive  } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'
import AddUpdateEmailSwipeModal from '../../../Components/Admin/AffiliateProgram/AddUpdateEmailSwipeModal'
import { createToaster } from '@meforma/vue-toaster';
import { Inertia } from '@inertiajs/inertia'

export default {
	layout: AuthLayout,
	props: {
		emailSwipes: Object,
		api_response: Object
	},
	components:{AddUpdateEmailSwipeModal},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const toast = createToaster();

		const cur_index = ref(null);

		const action 				= ref('add');

		const deleteModal 				= ref(null);
		const addUpdateEamilSwipeModal 	= ref(null);

		const selectedEmailSwipeContent = reactive({});

		const confirmDelete = (_index)=>{
			cur_index.value = _index;
			deleteModal.value.toggleModal();
		}

		const viewEmailSwipeContentModal = (_index,_action)=>{
			
			action.value = _action;
			
			if(_action=='update')
			{
				selectedEmailSwipeContent.id 			= props.emailSwipes.data[_index].id;
				selectedEmailSwipeContent.title 		= props.emailSwipes.data[_index].title;
				selectedEmailSwipeContent.email_format 	= props.emailSwipes.data[_index].email_format;
				selectedEmailSwipeContent.category 		= props.emailSwipes.data[_index].category;
				selectedEmailSwipeContent.status 		= props.emailSwipes.data[_index].status;
			}

			addUpdateEamilSwipeModal.value.setEmailSwipeContent(_action,selectedEmailSwipeContent);

			addUpdateEamilSwipeModal.value.toggleModal();

		}

		const deleteEmailSwipe = () => {
			action.value = "delete";
			var id = props.emailSwipes.data[cur_index.value].id;

			Inertia.delete('email-swipe/'+id, {
				preserveState: true,
				preserveScroll: true,
				only:['emailSwipes,api_response'],
				onSuccess: () => {
					deleteModal.value.toggleModal();
				},
			})
		}


		watch(()=>props.api_response, (value) => {
			
			if(value!=null)
			{
				var action_msg = action.value=='add' ? 'added' : (action.value=='delete' ? 'deleted' : 'updated');

				if(value.result=="success")
				{
					toast.show("Successfully "+action_msg, { type: value.result});
				}else
				{
					toast.show("Failed to "+action_msg, { type: "error"});
				}
			}
		})

		return{
			cur_index,
			action,
			selectedEmailSwipeContent,
			confirmDelete,
			deleteEmailSwipe,
			deleteModal,
			addUpdateEamilSwipeModal,
			viewEmailSwipeContentModal,
		}
	},
}
</script>
